import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import {browserHistory} from 'react-router';
import { bindActionCreators } from 'redux';
import * as actions from './redux/HeaderActions';
import * as searchActions from '../Search/redux/searchActions';
import styles from './Header.scss';
import BurgerDropDownMenu from '../BurgerDropDownMenu/BurgerDropDownMenu.jsx';
import Media from 'react-responsive';
import InlineSVG from 'react-svg-inline';
import searchIcon from '../../imgs/search-icon.svg';
import config from 'src/config';

import {getRatingPartners} from 'src/logic/api.js';

export class HeaderSecondLvl extends Component {
  constructor(props) {
     super(props);
     this.onSearch = this.onSearch.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
        children: nextProps.children
    });
  }

  onChangeSearch = (e) => {
    this.props.searchActions.onSearchInputChange(e.target.value);
  };

  onSearch = (e) => {
    e.preventDefault();
    const article = this.props.searchQuery;
    if(!article)
    {
      return;
    }
    browserHistory.push({pathname: config.routes.search, query: { article: article}});
    this.context.router.push(`${config.routes.search}?article=${article}`);
    /*don't work with small changes so use it for search*/
   this.props.searchActions.search(article);
  };

  render() {
    return (
      <div className={styles.headerWrapper}>
        <form
          onSubmit={this.onSearch}
          className={`${styles.header} ${styles.headerSearch}`}>
          {/* <BurgerDropDownMenu /> */}
          <Media query="(min-width: 1025px)">
            <input
              autoFocus={true}
              className={styles.searchInput}
              placeholder="Введите номер детали или укажите VIN-номер"
              type="text"
              value={this.props.searchQuery}
              onChange={this.onChangeSearch}/>
          </Media>
          <Media query="(max-width: 1024px)">
            <div className={styles.searchInputContainer}>
              <input
                className={styles.searchInput}
                placeholder="Номер детали или VIN-номер"
                type="text"
                value={this.props.searchQuery}
                onChange={this.onChangeSearch}/>
              <a href="#" className={styles.searchBtnMobile}>
                <InlineSVG svg={searchIcon} />
              </a>
            </div>
          </Media>
          <Media query="(min-width: 1025px)">
            <button
            className={styles.searchBtn}>
            Найти
            </button>
          </Media>
        </form>
      </div>
    );
  }
}

HeaderSecondLvl.contextTypes = {
    router: PropTypes.object.isRequired
};


function mapStateToProps(state) {
  return {
    ...state.search2Reducer,
    searchQuery: state.search2Reducer.searchQuery
  };
}


function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
    searchActions: bindActionCreators(searchActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HeaderSecondLvl);



/** WEBPACK FOOTER **
 ** ./src/components/Header/HeaderSecondLvl.jsx
 **/